'use client';

import React from 'react';
import { cn } from '@/lib/cn';
import { IconReviewStars, IconSearch } from '@repo/svgs';

export interface CollapsedSearchBarProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'children'> {
  placeholder?: string;
  onSearchClick?: () => void;
  onLeftIconClick?: () => void;
}

export default function CollapsedSearchBar({
  placeholder = 'Search address or building',
  onSearchClick,
  onLeftIconClick,
  className,
  id,
  style,
  ...rest
}: CollapsedSearchBarProps) {
  return (
    <div
      className={cn(
        // Container
        'flex items-center justify-between gap-2 rounded-full border bg-primary border-secondary shadow p-2',
        'w-auto',
        className,
      )}
      id={id}
      style={style}
      {...rest}
    >
      {/* Left icon button (review stars) */}
      <button
        type="button"
        aria-label="Reviews"
        className={cn(
          'inline-flex items-center justify-center rounded-full bg-active',
          'cursor-pointer',
          'h-9 w-9 p-2',
          'icon-accent',
        )}
        tabIndex={-1}
        onClick={onLeftIconClick}
      >
        <IconReviewStars width={16} height={16} />
      </button>

      <div className={cn('flex-1 min-w-0 rounded-full bg-primary px-2 text-secondary text-body-2')}>
        {placeholder}
      </div>

      {/* Right icon button (submit) */}
      <button
        type="button"
        aria-label="Submit search"
        className={cn(
          'inline-flex items-center justify-center rounded-full bg-accent hover:bg-accent-hover',
          'h-9 w-9 p-2',
          'icon-inverted',
        )}
        onClick={onSearchClick}
      >
        <IconSearch className="icon-inverted" width={16} height={16} />
      </button>
    </div>
  );
}
